import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  min-height: 580px;

  @media (min-width: 992px) {
    .reversed {
      flex-direction: row-reverse;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 992px) {
    flex-direction: column;
  }
`;

export const Description = styled.div`
  flex: 50%;
  padding: 1rem;

  h3 {
    margin: 0;
  }
  p {
    text-align: justify;
    font-weight: 300;
  }
  a {
    text-decoration: underline;
    :hover {
      text-shadow: 0px 3px 5px rgba(150, 150, 150, 0.3);
    }
  }
`;


// image size is 480*556
export const Image = styled.div`
  flex: 50%;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
  }
`;
